export default "__VITE_ASSET__Chono0qO__"